import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../../config/AxiosConfig';
import { JobGroupTargetListItemResp } from 'domain/payload/response/clientTransmora/jobGroupTarget/JobGroupTargetListItemResp';
import { JobGroupTargetDetailResp } from 'domain/payload/response/clientTransmora/jobGroupTarget/JobGroupTargetDetailResp';
import { JobGroupTargetSaveReq } from 'domain/payload/request/clientTransmora/jobGroupTarget/JobGroupTargetSaveReq';

const JobGroupTargetService = () => {
  const JobGroupTargetList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<JobGroupTargetListItemResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-job-group-target/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const JobGroupTargetDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<JobGroupTargetDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-job-group-target/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const JobGroupTargetSave = async (
    token: string,
    payload: JobGroupTargetSaveReq
  ): Promise<BaseResponse<JobGroupTargetDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/client-job-group-target/save`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const JobGroupTargetDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(
        `/v1/legacy/cms/client-job-group-target/delete`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { JobGroupTargetList, JobGroupTargetDetail, JobGroupTargetSave, JobGroupTargetDelete };
};

export default JobGroupTargetService;
